import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

// Inject keyframes for bounce animation (only once)
if (typeof document !== 'undefined' && !document.querySelector('#loading-overlay-keyframes')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'loading-overlay-keyframes';
  styleSheet.textContent = `
    @keyframes loadingOverlayBounce {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-20px); }
    }
    @keyframes loadingOverlayShadowPulse {
      0%, 100% { transform: scale(1); opacity: 0.3; }
      50% { transform: scale(0.6); opacity: 0.5; }
    }
  `;
  document.head.appendChild(styleSheet);
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    animation: 'loadingOverlayBounce 1s ease-in-out infinite',
  },
  icon: {
    fontSize: 64,
    color: 'var(--primary-color)',
    filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
  },
  shadow: {
    width: 40,
    height: 10,
    backgroundColor: 'rgba(0,0,0,0.3)',
    borderRadius: '50%',
    marginTop: 8,
    animation: 'loadingOverlayShadowPulse 1s ease-in-out infinite',
  },
  text: {
    fontSize: 18,
    fontWeight: 600,
    marginTop: 20,
    color: '#FFFFFF',
  },
};

/**
 * LoadingOverlay - A fullscreen loading overlay with animated icon
 * @param {boolean} isLoading - Whether to show the overlay
 * @param {React.ReactNode} icon - The icon component to display (defaults to LoadingOutlined)
 * @param {string} text - The text to display below the icon (defaults to "Loading...")
 */
export default function LoadingOverlay({ isLoading, icon, text = "Loading..." }) {
  if (!isLoading) return null;

  const IconComponent = icon || <LoadingOutlined style={styles.icon} />;

  return (
    <div style={styles.overlay}>
      <div style={styles.iconContainer}>
        {React.isValidElement(icon) 
          ? React.cloneElement(icon, { style: { ...styles.icon, ...icon.props?.style } })
          : IconComponent
        }
        <div style={styles.shadow} />
      </div>
      <div style={styles.text}>{text}</div>
    </div>
  );
}
